import { useState, useEffect } from 'react';
import { formatDateTimeRelative, type SupportedLocale } from '~/lib/utils';

interface LiveTimestampProps {
  date: Date | number | string;
  className?: string;
  updateInterval?: number; // milliseconds
  locale?: SupportedLocale;
}

export function LiveTimestamp({
  date,
  className,
  updateInterval = 30000,
  locale,
}: LiveTimestampProps) {
  const [_, setCurrentTime] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, updateInterval);

    return () => clearInterval(interval);
  }, [updateInterval]);

  return <span className={className}>{formatDateTimeRelative(date, locale)}</span>;
}
